import axios from "axios";
import jsYaml from "js-yaml";
import UnresolvedSchema from "../model/unresolvedSchema";
import UnresolvedCategory from "../model/unresolvedCategory";

type Markers = {
    schemas: { [name: string]: UnresolvedSchema };
    categories: { [name: string]: UnresolvedCategory };
};

let result: Markers | undefined = undefined;

export default async function getMarkers(): Promise<Markers> {
    if (!result) {
        // Pour le développement local, décommenter la ligne suivante :
        // const url = "http://teo.localhost:8003/public/markers.yml";
        const url = "https://ikno.teo-online.net/next/public/markers.yml";
        const headers: { [key: string]: string } = {};

        const response = await axios.get(url, { headers });
        result = jsYaml.load(response.data) as Markers;
    }

    return result;
}
